import { showCustomSwal } from "../../components/customswal/Customswal";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { showConfirm } from "../../utility/showconfirm";
const handleurlqueryexec = async (href, openmodal) => {
  // let url = href;


  //  const params = new URLSearchParams(href?.split("?")[1]);
  //   let query = params.get("query");
// console.log(query,"query")
  try {
    openmodal(true)
    const params = new URLSearchParams(href.split("?")[1]);
    let query = params.get("query");
//     if (url.includes("?query=")) {
//   let base = url.split("?query=")[0] + "?query=";
//   let queryPart = url.split("?query=")[1];

//   let encodedQuery = encodeURIComponent(queryPart);
//   url = base + encodedQuery;
// }

// const params = new URLSearchParams(url.split("?")[1]);
// let query = decodeURIComponent(params.get("query"));

console.log(query,"query")
    const obj = {
      query: `${query}`,
      queryArr: []
    };
    const resp = await Hexapi(obj);
    console.log(resp,"resp")
    if (resp?.[""]?.length > 0) {
      const { command, msg } = resp[""][0];

      // if (command == 1 || command == 0) {
        showConfirm({
          content: msg,
          hideCancel: true
        }).then(()=>{
          openmodal(false)
        })
      // }
    } else {
      showConfirm({
        content: `Unexpected response structure`,
        hideCancel: true
      });
    }
  } catch (error) {
    console.error(error);
     if(error.message =="SQL Error occurred"){
      showCustomSwal("Error occurred please try again")
    }
     openmodal(false)
  } finally {
    openmodal(false)
  }
};

const handleviewopen = async (str, url,openmodal,setattachmentdata) => {

  openmodal(true)
  try {
    const fileParts = str && str?.split('.');
    const fileExt =  str && '.' + fileParts?.at(-1);
    const fileName =  str && fileParts?.slice(0, -1)?.join('.');

    let attachmentId = null;
    const params = new URLSearchParams(url.split("?")[1]);
    attachmentId = params.get("attachmentids");
console.log(attachmentId,"attachmentId")
    if (attachmentId) {
      console.log("dgdhd")
        setattachmentdata({
          attachmentId:attachmentId,
          filename:fileName,
          fileext:fileExt
        });
    }
    openmodal(false)
  } catch (error) {
    console.log(error,"error")
  }
};
export const getlinks = (navigate, href,openmodal,setattachmentdata,text) => {
  console.log(href,"href")
const prefix="hextrackhr://www.trackhr.com/"
  let route = "none";
  if (href.includes("sourcequery")) {
    let queryParams = href?.split("?")[1]?.split("&");

    if (queryParams) {
      let sourcequery = queryParams[0].split("=")[1];
      let name = queryParams[1].split("=")[1];
      let filter = queryParams[2].split("=")[1];

      let encodedParams = btoa(
        `name=${name}&sourcequery=${sourcequery}&filter=${filter}`
      );
      route = `/dynamicreport?${encodedParams}`
    }
  }

  else if (href.includes(`${prefix}WorkHistory`)) {
    const params = href.split("?")[1].split("&");
    route = `/workhistory?${btoa(
      `id=${-1}&name=${params[1].split("=")[1]}&shiftid=${params[0].split("=")[1]}`
    )}`;

  } else if (href.includes(`${prefix}Activity`)) {
    const params = href.split("?")[1].split("&");
    route = `/activityhistory?${btoa(
      `id=${-1}&page=activityhistory&activityid=${params[0].split("=")[1]}`
    )}`;

  } else if (href.includes(`${prefix}Ticket`)) {
    const params = href.split("?")[1].split("&");
    route = `/tickets?${btoa(
      `id=${-1}&tid=${params[0].split("=")[1]}&name=${-1}`
    )}`;

  } else if (href.includes(`${prefix}RedFlag`)) {
    const params = href.split("?")[1].split("&");
    route = `/redflag?${btoa(
      `id=${params[0].split("=")[1]}&name=${-1}`
    )}`;

  } else if (href.includes(`${prefix}UserProfile`)) {
    const params = href.split("?")[1].split("&");
    route = `/profile?${btoa(
      `id=${params[0].split("=")[1]}&page=Userprofile`
    )}`;

  } else if (href.includes(`${prefix}EmpLeaves`)) {
    const params = href.split("?")[1].split("&");
    route = `/leaves?${btoa(
      `id=${params[0].split("=")[1]}&name=${params[1].split("=")[1]}`
    )}`;

  } else if (href.includes(`${prefix}EmpApprovals`)) {
    const params = href.split("?")[1].split("&");
    route = `/approvals?${btoa(
      `approvaltype=${params[0].split("=")[1]}&approvalstage=${params[1].split("=")[1]}`
    )}`;

  } else if (href.includes(`${prefix}TicketList`)) {
    route = `/tickets`;

  }

  else if (href.includes(`${prefix}EmpTimeline`)) {
    const params = href.split("?")[1].split("&");
    route = `/locationtimeline?${btoa(
      `id=${params[0].split("=")[1]}&shiftid=${params[2].split("=")[1]}&name=${params[1].split("=")[1]}`
    )}`;
  }

  else if (href.includes(`${prefix}LeaderboardReport`)) {
    route = `/leaderboard?${btoa(`IsShowArrow=true`)}`;
  }
  else if (href.includes("Home")) {
    route = `/home`;

  }

  else if (href.includes(`${prefix}ViewAttachment`)) {
    handleviewopen(text,href,openmodal,setattachmentdata)
    return
  }
  else if (href.includes(`${prefix}KPIPendencyList`)) {
    const params = href.split("?")[1].split("&");
    route = `/kpipendency?${btoa(
      `id=${params[0].split("=")[1]}&isShowArrow=true&username=${params[1].split("=")[1]}`
    )}`;

  }
  else if (href.includes(`${prefix}KPIPendency`)) {
    const params = href.split("?")[1].split("&");
    route = `/kpipendency?${btoa(`kpiid=${params[0].split("=")[1]}&IsShowArrow=true`)}`;
  }
  else if (href.includes(`${prefix}KPI`)) {
    const params = href.split("?")[1].split("&");
    route = `/kpidetails${btoa(`id=${-1}&kpiid=${params[0].split("=")[1]}&IsShowArrow=true`)}`;
  }
  else if (href.includes(`${prefix}ToDoList`)) {
    const params = href.split("?")[1].split("&");
    console.log(`id=${params[0]?.split("=")[1]}&name=${params[1]?.split("=")[1]}`,"dfwyuyiso")
    route = `/todo?${btoa(`id=${params[0]?.split("=")[1]}&name=${params[1]?.split("=")[1]}`)}`;
  }
  else if (href.includes(`${prefix}AIChatbot`)) {
    const params = href.split("?")[1].split("&");
const data=`${decodeURIComponent(params[0].split("=")[1])}`

window.postMessage(
    { type: "DEFQUES",  data},
    "*"
  );

    route = `/novachatbot`;
  }
  else if (href.includes(`${prefix}urlqueryexec`)) {
    handleurlqueryexec(href, openmodal)
    return;
  } else if (href.includes(`${prefix}Meeting`)) {
    showConfirm({
      content: "Use mobile app to execute this action.",
      hideCancel: true
    })
    return;
  } else if (href.includes(`${prefix}ManagerQRScan`)) {
    showConfirm({
      content: "Use mobile app to execute this action.",
      hideCancel: true
    })
    return;
  } else if (href.includes(`${prefix}AddMeeting`)) {
    showConfirm({
      content: "Use mobile app to execute this action.",
      hideCancel: true
    })
    return;
  }
  if (route !== "") {
    navigate(route)
  }
}

// import Hexapi from "../../utility/HexAPI/Hexapi";
// import { showConfirm } from "../../utility/showconfirm";
//  const handleurlqueryexec = async (href, loadingmodalclose,loadingmodalopen) => {
//   try {
//     loadingmodalopen()

//     const params = new URLSearchParams(href.split("?")[1]);
//     let query = params.get("query");

//     const obj = {
//       query: `${query}`,
//       queryArr: []
//     };

//     const resp = await Hexapi(obj);

//     if (resp?.[""]?.length > 0) {
//       const { command, msg } = resp[""][0];

//       if (command == 1 || command == 0) {
//         showConfirm({
//           content: msg,
//           hideCancel: true
//         });
//       }
//     } else {
//       showConfirm({
//         content: `Unexpected response structure`,
//         hideCancel: true
//       });
//     }
//   } catch (error) {
//     console.error(error);
//   } finally {
//     loadingmodalclose()
//   }
// };

// export const getlinks=(navigate,href ,empid,empname,loadingmodalclose,loadingmodalopen,handleViewAttachment)=>{
//   console.log(href,"href")
//     let route ="none";

//     if (href.includes("sourcequery")) {
//         let queryParams = href?.split("?")[1]?.split("&");

//         if (queryParams) {
//           let sourcequery = queryParams[0].split("=")[1];
//           let name = queryParams[1].split("=")[1];
//           let filter = queryParams[2].split("=")[1];

//           let encodedParams = btoa(
//             `name=${name}&sourcequery=${sourcequery}&filter=${filter}`
//           );

//           route=`/dynamicreport?${encodedParams}`
//           // navigate(`/dynamicreport?${encodedParams}`);
//         }
//       }

//   else if (href.includes("WorkHistory")) {
//     const params = href.split("?")[1].split("&");
//     route = `/workhistory?${btoa(
//       `id=${empid}&name=${params[1].split("=")[1]}&shiftid=${params[0].split("=")[1]}`
//     )}`;

//   } else if (href.includes("Activity")) {
//     const params = href.split("?")[1].split("&");
//     route = `/activityhistory?${btoa(
//       `id=${empid}&page=activityhistory&activityid=${params[0].split("=")[1]}`
//     )}`;

//   } else if (href.includes("Ticket")) {
//     const params = href.split("?")[1].split("&");
//     route = `/tickets?${btoa(
//       `id=${empid}&tid=${params[0].split("=")[1]}&name=${empname}`
//     )}`;

//   } else if (href.includes("RedFlag")) {
//     const params = href.split("?")[1].split("&");
//     route = `/redflag?${btoa(
//       `id=${params[0].split("=")[1]}&name=${empname}`
//     )}`;

//   } else if (href.includes("UserProfile")) {
//     const params = href.split("?")[1].split("&");
//     route = `/profile?${btoa(
//       `id=${params[0].split("=")[1]}&page=Userprofile`
//     )}`;

//   } else if (href.includes("EmpLeaves")) {
//     const params = href.split("?")[1].split("&");
//     route = `/leaves?${btoa(
//       `id=${params[0].split("=")[1]}&name=${params[1].split("=")[1]}`
//     )}`;

//   } else if (href.includes("EmpApprovals")) {
//     const params = href.split("?")[1].split("&");
//     route = `/approvals?${btoa(
//       `approvaltype=${params[0].split("=")[1]}&approvalstage=${params[1].split("=")[1]}`
//     )}`;

//   } else if (href.includes("TicketList")) {
//     route = `/tickets`;

//   }

//   else if (href.includes("EmpTimeline")) {
//     const params = href.split("?")[1].split("&");
//     route = `/locationtimeline?${btoa(
//       `id=${params[0].split("=")[1]}&shiftid=${params[2].split("=")[1]}&name=${params[1].split("=")[1]}`
//     )}`;
//   }

//   else if (href.includes("LeaderboardReport")) {
//     route = `/leaderboard?${btoa(`IsShowArrow=true`)}`;
//   }
//   else if (href.includes("Home")) {
//     route = `/home`;

//   }

//   else if(href.includes("ViewAttachment")){
//     handleViewAttachment()
//     return
//   }
//   else if (href.includes("KPIPendencyList")) {
//     const params = href.split("?")[1].split("&");
//     route = `/kpipendency?${btoa(
//     `id=${params[0].split("=")[1]}&isShowArrow=true&username=${params[1].split("=")[1]}`
//   )}`;

//   }
//   else if (href.includes("KPIPendency")) {
//     const params = href.split("?")[1].split("&");
//     route = `/kpipendency?${btoa(`kpiid=${params[0].split("=")[1]}&IsShowArrow=true`)}`;
//   }
//   else if (href.includes("KPI")) {
//     const params = href.split("?")[1].split("&");
//     route = `/kpidetails${btoa(`id=${empid}&kpiid=${params[0].split("=")[1]}&IsShowArrow=true`)}`;
//   }
//     else if (href.includes("ToDoList")) {
//     const params = href.split("?")[1].split("&");
//     route = `/todo${btoa(`id=${params[0].split("=")[1]}&name=${params[1].split("=")[1]}&IsShowArrow=true`)}`;
//   }
//     else if (href.includes("AIChatbot")) {

//     const params = href.split("?")[1].split("&");
//     route = `/novachatbot?${btoa(decodeURIComponent(`defques=${params[0].split("=")[1]}`))}`;
//   }
//   else if(href.includes("urlqueryexec")){
//           handleurlqueryexec(href,loadingmodalclose,loadingmodalopen)
//           return;
//       }else if(href.includes("Meeting")){
//           showConfirm({
//                               content: "Use mobile app to execute this action.",
//                               hideCancel: true
//                             })
//                             return;
//       }else if(href.includes("ManagerQRScan")){
//           showConfirm({
//                               content: "Use mobile app to execute this action.",
//                               hideCancel: true
//                             })
//                             return;
//       }else if(href.includes("AddMeeting")){
//           showConfirm({
//                               content: "Use mobile app to execute this action.",
//                               hideCancel: true
//                             })
//                             return;
//       }
//       if(route !==""){
//         navigate(route)
//       }
// }